
<template>
     <div class="text-nowrap">
        <a :href="link?link:'#'" class="avatar rounded-circle bg-orange" :class="'avatar-' + avatarSize">
          <span v-if="!logo">{{locationInitials}}</span>
          <div v-if="logo" class="location-icon__image"  :style="'background-image:url(' +logo +')'"></div>
        </a>
        <span class="text-nowrap ml-2" :class="logo?'location-icon__name':''">{{name}}</span>
     </div>
</template>

<script>
 
  export default {
    name: 'location-icon',
    components: {
     
    },

    props:[
        'logo',
        'name',
        'link',
        'avatarSize'
    ],

    data() {
      return {
        
      };
    },
    computed:{
      locationInitials:function(){

        if(!this.name) return ''

        let split = this.name.split(' ');
        let word = null;
        let initials = '';
        for (let index = 0; index < split.length; index++) {
          if(index > 2) break;
          word = split[index];
          initials += word.substring(0,1);
        }
        return initials;
      }
    },
    methods: {
       
    },

    watch:{
        
    }
  }
</script>

<style lang="scss" scoped>
  .location-icon__image{
    height: 100%;
    width: 100%;
    background: white no-repeat center;
    background-size: contain;
    background-size: 80%;
    box-shadow: 0px 1px 3px 0px rgba(212,205,212,1);
    border-radius: 50%;
  }

  .location-icon__name{
    top: -10px;
    position: relative;
  }
</style>